// @flow

import prefersReducedTransparency from './prefersReducedTransparency';
import transparencyPreferences, { type TransparencyPreference } from './transparencyPreferences';

export default prefersReducedTransparency;

export { transparencyPreferences };
export type { TransparencyPreference };
